'use client';

var _excluded = ["className", "description", "image", "url", "onClick"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import classNames from 'classnames';
import { useCallback } from 'react';
import { Pinterest } from "../../icons/index.mjs";
import { openWindow } from "../../lib/index.mjs";
import { getPinterestShareUrl } from "./lib/index.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
export function PinterestButton(_ref) {
  var {
      className,
      description,
      image,
      url,
      onClick
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  var pinterestShareUrl = getPinterestShareUrl({
    description,
    image,
    url
  });
  var handlePinterestClick = useCallback(event => {
    event.preventDefault();
    openWindow(pinterestShareUrl, 575, 400);
    if (onClick) {
      onClick(event);
    }
  }, [onClick, pinterestShareUrl]);
  return /*#__PURE__*/_jsx("a", _objectSpread(_objectSpread({
    className: classNames('prezly-slate-pinterest-button', className),
    href: pinterestShareUrl,
    onClick: handlePinterestClick,
    rel: "noreferrer noopener",
    target: "_blank",
    title: "Save this Pin!"
  }, props), {}, {
    children: /*#__PURE__*/_jsx(Pinterest, {
      className: "prezly-slate-pinterest-button__icon"
    })
  }));
}